module.exports = __webpack_public_path__ + "img/study-group.e34b8d95.jpeg";